import { inject } from '@angular/core';
import { GvTaTrackerAssignmentApiService } from '@shared/services';
import { PopoverHandlerConfig, PopoverConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';
import { endTrackerAssignmentFormConfig } from '@shared/components/edit-create-form';

export const endTrackerAssignmentPopoverConfig = (
    onSuccess: () => void,
    onCancel: () => void
): PopoverConfig => {
    const trackerAssignmentApiService = inject(GvTaTrackerAssignmentApiService);

    return {
        width: '450px',
        title: 'Kết thúc phân công Tracker',
        dismissable: true,
        styleClass: 'p-fluid',
        formConfig: endTrackerAssignmentFormConfig(),
        actions: [
            defaultCancelAction,
            { ...defaultConfirmAction, label: 'Kết thúc', severity: 'warn' }
        ],
        handlerConfig: {
            service: trackerAssignmentApiService,
            method: 'endAssignment',
            entityLabel: 'kết thúc phân công',
            commonDataTransform: (formValue: any) => ({
                id: formValue.id,
                toDate: formValue.toDate
            }),
            initialDataTransform: (rawData: any) => ({
                id: rawData.id,
                gvTaEmployeePosition: rawData.gvTaEmployeePosition,
                trackerEmployeePosition: rawData.trackerEmployeePosition,
                fromDate: rawData.fromDate,
                toDate: rawData.toDate || null
            }),
            onSuccess,
            onCancel
        } as PopoverHandlerConfig
    };
};

